// Accounting Cashiers Vuex

import state from './transferStates.js'
import * as getters from './transferGetters.js'
import * as mutations from './transferMutations.js'
import * as actions from './transferActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
